var $c9a532d1c973af61$exports = {};
$c9a532d1c973af61$exports = {
    "dropzoneLabel": `\u{653E}\u{7F6E}\u{533A}\u{57DF}`,
    "selectPlaceholder": `\u{9009}\u{62E9}\u{4E00}\u{4E2A}\u{9879}\u{76EE}`,
    "tableResizer": `\u{5C3A}\u{5BF8}\u{8C03}\u{6574}\u{5668}`,
    "colorSwatchPicker": `Color swatches`
};


export {$c9a532d1c973af61$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
